import * as Yup from "yup"

// Custom method to validate phone numbers
Yup.addMethod(Yup.string, "phone", function (errorMessage) {
  return this.test("phone", errorMessage, function (value) {
    const { path, createError } = this

    // Validate based on custom logic
    if (value) {
      if (value.length === 12) {
        if (!value.startsWith("+") || !/^\+\d{11}$/.test(value)) {
          return createError({ path, message: errorMessage })
        }
      } else if (value.length === 10) {
        if (!/^\d{10}$/.test(value)) {
          return createError({ path, message: errorMessage })
        }
      } else {
        return createError({ path, message: errorMessage })
      }
    }

    // If no value or valid format, consider it valid to allow optional fields
    return true
  })
})

export const applyNowValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(/^[a-zA-Z ]{2,30}$/, "Invalid first name")
    .required("Please enter your first name"),
  lastName: Yup.string()
    .matches(/^[a-zA-Z ]{2,30}$/, "Invalid last name")
    .required("Please enter your last name"),
  smsfName: Yup.string().matches(/^[a-zA-Z ]{2,30}$/, "Invalid SMSF name"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Please enter your email address"),
  phone: Yup.string()
    .phone("Invalid Phone Number")
    .required("Phone number is required"),
  postalCode: Yup.string().matches(/^[0-9]{4}$/, "Invalid Postcode"),
  estimatedLoanValue: Yup.string().test(
    "is-numerical-or-empty",
    "Estimated loan amount must be a whole number or empty",
    value => {
      // Allow the field to be optional: pass validation if it's empty
      if (!value) return true

      // Ensure value is a string, remove commas, and then check if it's a whole number
      const stringValue = value.toString().replace(/,/g, "")

      // Test if the string is a whole number
      return /^\d+$/.test(stringValue)
    }
  ),
})

const australianPhoneRegex =
  /^(\+61[2-4789][0-9]{8}|0[2-4789][0-9]{8}|1300[0-9]{6}|1800[0-9]{6}|13[0-9]{4})$/

export const accreditationValidationSchema = Yup.object({
  companyName: Yup.string().required("Company name is required"),
  abn: Yup.string()
    .matches(/^\d{11}$/, "ABN must be 11 digits")
    .optional(),
  aggregator: Yup.string().optional(),
  profession: Yup.string().required("Profession is required"),
  licenceType: Yup.string().required("Licence Type is required"),
  legalFirstName: Yup.string()
    .matches(/^[a-zA-Z ]+$/, "Only alphabets are allowed")
    .required("Legal first name is required"),
  lastName: Yup.string()
    .matches(/^[a-zA-Z ]+$/, "Only alphabets are allowed")
    .required("Last name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  mobilePhone: Yup.string()
    .matches(australianPhoneRegex, "Mobile number must be in Australian format")
    .required("Mobile number is required"),
  phone: Yup.string()
    .matches(australianPhoneRegex, "Phone number must be in Australian format")
    .optional(),
  address: Yup.string().required("Address is required"),
  productInterest: Yup.string().required("Product interest is required"),
})